import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/movieDetails/movieDetailsClickableArea.sss';

export default class MovieDetailsClickableArea extends Component {

	constructor(props) {
		super(props);

		this.stickAndScale = this.stickAndScale.bind(this);

		Store.on('STICK_AND_SCALE', this.stickAndScale);
	}

	componentWillUnmount() {
		Store.off('STICK_AND_SCALE', this.stickAndScale);
	}

	stickAndScale(percentage) {
		if (!Store.get().client.isDesktopSize) {
			const minHeight = 0;
			const maxHeight = (window.innerWidth / 16 * 9) - 80 - minHeight;
			const height = minHeight + (maxHeight * percentage);
			return this.clickable.style.height = height + 'px';
		}
	}

	handleClick(e, fallbackClick) {
		// the scroller element is preventing access to the buttons below the TT, this is a workaround
		const hitElements = document.elementsFromPoint(e.clientX, e.clientY);
		const button = hitElements.find(element => element.nodeName === 'BUTTON');
		if (button) {
			button.click();
		} else {
			fallbackClick();
		}
	}

	render(props) {
		return (
			<div
				ref={ref => this.clickable = ref}
				class={joinClasses(s.clickable, props.isWidget && s.widget, props.homeEnt && s.homeEnt)}
				onClick={(e) => this.handleClick(e, props.fallbackClickHandler)}
				key='clickableMovieDetails'
			/>
		);
	}
}
